<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Parameters">
        <v-card-actions>
          <a @click="$router.back()">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
              style="opacity: 0.6">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </a>
        </v-card-actions>
        <v-card-text class="pt-0 pr-1"
          :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-text-field :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }" v-model="search"
            append-icon="mdi-magnify" class="ml-auto mb-2" label="Search" hide-details single-line
            style="max-width:350px;" />
          <v-btn v-if="isWrite" elevation="1" v-on:click="modalOpen()" :class="{ 'mt-2': $vuetify.breakpoint.xs }"
            color="accent">
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </v-card-text>
        <v-divider class=" my-0 " />
        <v-data-table :headers="headers" :items="seqDataArray" :search.sync="search">
          <template v-slot:item.gradeSkill="{ item }">
            <span>{{ item.gradeSubSkill.gradeSkill.name }}</span>
          </template>
          <template v-slot:item.gradeSubSkill="{ item }">
            <span>{{ item.gradeSubSkill.name }}</span>
          </template>
          <template v-slot:item.name="{ item }">
            <span>
              {{ item.name }}
            </span>
            <!-- <hr> -->
          </template>
          <template v-slot:item.description="{ item }">
            <span>
              {{ item.description ? item.description : '---' }}
            </span>
          </template>
          <template v-slot:item.remark="{ item }">
            <span>
              {{ item.remark ? item.remark : '---' }}
            </span>
          </template>
          <template v-slot:item.term="{ item }">
            <div v-for="(obj, i) in item.gradePrameterTermMaps" :key="i">
              <span v-for="(item, key) in obj.academicTerms" :key="key">
                {{ item.name ? item.name : '---' }}
              </span>
            </div>
            <!-- {{ getTermList(item.gradePrameterTermMaps) }} -->
            <!-- <hr> -->
          </template>
          <template v-slot:item.actions="{ item }" v-if="isWrite">
            <div>
              <v-btn color="success" class="px-2 ml-1 ma-1" @click="getSingleParam(item.id)" min-width="0" small>
                <v-icon small> mdi-pencil </v-icon>
              </v-btn>
              <v-btn v-if="!item.deletedAt" color="error" class="px-2 ml-1 ma-1" min-width="0" small
                @click="getDeleteData(item.id)">
                <v-icon small> mdi-delete </v-icon>
              </v-btn>
              <v-btn v-if="item.deletedAt" class="px-2 ml-1 ma-1" color="info" min-width="0" small
                @click="getRestoreData(item.id)">
                <v-icon small> mdi-restore</v-icon>
              </v-btn>
              <!-- <hr> -->
            </div>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
      </material-card>
      <v-dialog persistent max-width="900" v-model="modalOk" :active="modalOk" :on-cancel="() => {
        ; (modalOk = false), clearData()
      }
        ">
        <form @submit.prevent="addSkills">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title>Add Parameters</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="() => {
                  ; (modalOk = false), clearData()
                }
                  ">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field label="Name*" v-model.trim="parameterName" placeholder="Parameter" required>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea rows="2" label="Description" clearable clear-icon="mdi-close-circle" v-model.trim="desc"
                    placeholder="write" maxlength="200" counter="200"> </v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Remark" v-model.trim="remark" placeholder="remark" maxlength="200" counter="200">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Position" v-model.trim="position" placeholder="position" type="number">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete required multiple label="Term *" clearable v-model="termId" :items="termList" key="id"
                    item-value="id" item-text="name">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-card-actions class="justify-end">
                    <v-btn color="success" @click="addParameter">{{ editMode ? 'Save' : 'Add' }}</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </form>
      </v-dialog>
      <!-- Delete Modal Dialog -->
      <v-dialog persistent max-width="900" v-model="deleteModel" :active="deleteModel" :on-cancel="() => {
        ; (deleteModel = false), clearData()
      }
        ">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title>Are you sure you want to Delete!</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="() => {
                ; (deleteModel = false), clearData()
              }
                ">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="mt-3">
            <v-row>
              <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                <v-row class="mt-1 justify-center">
                  <strong>Name: </strong>
                  <p>{{ parameterName }}</p>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="3" md="3" lg="3" sm="3" xs="3">
                <v-row class="ml-4">
                  <strong>Term: </strong>
                  <p>{{ termId }}</p>
                </v-row>
              </v-col>
              <v-col cols="3" md="3" lg="3" sm="3" xs="3">
                <v-row>
                  <strong>Skill: </strong>
                  <p>{{ skill }}</p>
                </v-row>
              </v-col>
              <v-col cols="3" md="3" lg="3" sm="3" xs="3">
                <v-row>
                  <strong>Sub Skill: </strong>
                  <p>{{ subSkill }}</p>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                <v-card-actions class="justify-center">
                  <v-btn color="primary" @click="deleteGradeParameter(termID)">Confirm</v-btn>
                  <v-btn color="info" @click="() => {
                    ; (deleteModel = false), clearData()
                  }">Cancel</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Restore Modal Dialog -->
      <v-dialog persistent max-width="900" v-model="restoreModel" :active="restoreModel" :on-cancel="() => {
        ; (restoreModel = false), clearData()
      }
        ">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title>Are you sure you want to Restore!</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="() => {
                ; (restoreModel = false), clearData()
              }
                ">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="mt-03">
            <v-row>
              <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                <v-row class="mt-1 justify-center">
                  <strong>Name: </strong>
                  <p>{{ parameterName }}</p>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="3" md="3" lg="3" sm="3" xs="3">
                <v-row>
                  <strong>Term: </strong>
                  <p>{{ termId }}</p>
                </v-row>
              </v-col>
              <v-col cols="3" md="3" lg="3" sm="3" xs="3">
                <v-row>
                  <strong>Skill: </strong>
                  <p>{{ skill }}</p>
                </v-row>
              </v-col>
              <v-col cols="3" md="3" lg="3" sm="3" xs="3">
                <v-row>
                  <strong>Sub Skill: </strong>
                  <p>{{ subSkill }}</p>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                <v-card-actions class="justify-center">
                  <v-btn color="primary" @click="restoreGradeParameter(termID)">Confirm</v-btn>
                  <v-btn color="info" @click="() => {
                    ; (restoreModel = false), clearData()
                  }">Cancel</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
export default {
  props: ['skillId', 'subSkillId', 'subSkillName'],
  components: {
    MaterialCard
  },
  data () {
    return {
      parameterName: '',
      skill: '',
      subSkill: '',
      search: '',
      isLoading: false,
      data: [],
      total: '',
      editMode: false,
      modalOk: false,
      desc: '',
      remark: '',
      position: null,
      isWrite: false,
      headers: [
        { text: 'Terms', value: 'term', align: 'center', sortable: true },
        { text: 'Skill', value: 'gradeSkill', align: 'center', sortable: true },
        { text: 'Sub Skill', value: 'gradeSubSkill', align: 'center', sortable: true },
        { text: 'Parameters', value: 'name', align: 'center', sortable: true },
        { text: 'Description', value: 'description', align: 'center', sortable: true },
        { text: 'Remark', value: 'remark', align: 'center', sortable: true },
        { text: 'Action', value: 'actions', align: 'center', sortable: false }
      ],
      termList: [],
      termId: '',
      seqDataArray: [],
      seqDataObjects: {},
      restoreModel: false,
      deleteModel: false,
      termID: null,
      termValues: null
    }
  },
  created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    if (this.subSkillId) {
      this.getParameters()
    }
    this.getTerms()
  },
  methods: {
    searchResult (value) {
      let tempRecipes = this.seqDataArray
      if (value !== '' && value) {
        tempRecipes = _.filter(tempRecipes, (item) => {
          if (_.includes(item, value)) {
            return item
          } else if (_.includes(item.gradeSubSkill, value)) {
            return item
          } else if (_.includes(item.gradeSubSkill.gradeSkill, value)) {
            return item
          } else if (_.includes(item.gradePrameterTermMaps[0].academicTerms[0], value)) {
            return item
          }
        }
        )
        this.seqDataArray = tempRecipes
      }
      if (value === '') {
        this.getParameters()
      }
      return tempRecipes
    },
    getTermList: function (values) {
      let termName = []
      if (_.isArray(values)) {
        values.forEach((item) => {
          if (_.isArray(item.academicTerms)) {
            item.academicTerms.forEach((obj) => {
              if (obj.name) {
                termName.push(obj.name)
              }
            })
          }
        })
        if (termName.length > 0) {
          return termName.toString()
        } else {
          return '---'
        }
      }
      return '---'
    },
    getTerms: async function () {
      try {
        this.isLoading = true
        let data = await http.get(`${constants.API_URL}/api/grade-module/academic-terms`)
        this.termList = data.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
    },
    addParameter: async function () {
      if (this.parameterName === '') {
        this.errMsg('Name cannot be empty!')
        return false
      }
      if (this.termId.length < 1) {
        this.errMsg('Term value caanot be empty')
        return false
      }
      let academicTermData = _.map(this.termList, a => {
        return {
          'academicTermID': a.id,
          'isActive': this.termId.includes(a.id)
        }
      })
      if (this.editMode) {
        var formData = {
          name: this.parameterName,
          isActive: true,
          academicTermData
        }
        formData.description = this.desc
        formData.remark = this.remark
        formData.position = this.position
        // if (this.desc) {
        // formData.description = this.desc
        // }
        // if (this.remark) {
        //   formData.remark = this.remark
        // }
        // if (this.position) {
        //   formData.position = this.position
        // }
      } else {
        formData = {
          gradeSubSkillID: this.subSkillId,
          gradeParameters: [
            {
              name: this.parameterName,
              isActive: true,
              academicTermData
            }
          ]
        }
        if (this.desc) {
          formData.gradeParameters[0].description = this.desc
        }
        if (this.remark) {
          formData.gradeParameters[0].remark = this.remark
        }
        if (this.position) {
          formData.gradeParameters[0].position = this.position
        }
      }
      let url = this.editMode ? `${constants.API_URL}/api/grade-module/parameter/${this.selectedId}` : `${constants.API_URL}/api/grade-module/parameter`
      try {
        let { data } = await http.post(url, formData)
        this.okMsg(data.toString())
        this.getParameters()
        this.modalOk = false
        this.clearData()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    modalOpen () {
      this.modalOk = true
    },
    getParameters: async function () {
      try {
        this.isLoading = true
        const result = await http.get(`${constants.API_URL}/api/grade-module/allParameter?gradeSkillID=${this.skillId}&&gradeSubSkillID=${this.subSkillId}&&search=${this.search}`)
        this.seqDataArray = result.data
        console.log('seqDataArray:::', this.seqDataArray)
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    getSingleParam: async function (id) {
      this.editMode = true
      this.selectedId = id
      try {
        const { data } = await http.get(`${constants.API_URL}/api/grade-module/parameter/${id}`)
        this.modalOk = true
        this.parameterName = data.gradeSubSkills[0].gradeParameters[0].name
        this.desc = data.gradeSubSkills[0].gradeParameters[0].description ? data.gradeSubSkills[0].gradeParameters[0].description : ' '
        this.remark = data.gradeSubSkills[0].gradeParameters[0].remark ? data.gradeSubSkills[0].gradeParameters[0].remark : ' '
        this.position = data.gradeSubSkills[0].gradeParameters[0].position ? data.gradeSubSkills[0].gradeParameters[0].position : null
        this.termId = _.map(data.gradeSubSkills[0].gradeParameters[0].gradePrameterTermMaps, a => a.academicTermID)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    getDeleteData: async function (id) {
      try {
        let tremsArray = []
        const { data } = await http.get(`${constants.API_URL}/api/grade-module/parameter/${id}`)
        this.parameterName = data.gradeSubSkills[0].gradeParameters[0].name
        this.skill = data.name
        this.subSkill = data.gradeSubSkills[0].name
        // this.termId = data.gradeSubSkills[0].gradeParameters[0].gradePrameterTermMaps[0].academicTerms[0].name
        this.termValues = data.gradeSubSkills[0].gradeParameters[0].gradePrameterTermMaps
        this.termValues.forEach((obj) => {
          if (_.isArray(obj.academicTerms)) {
            obj.academicTerms.forEach((item) => {
              if (item.name) {
                tremsArray.push(item.name)
              }
            })
          }
        })
        if (tremsArray.length > 0) {
          this.termId = tremsArray.toString()
        }
        this.termID = data.gradeSubSkills[0].gradeParameters[0].id
        this.deleteModel = true
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    getRestoreData: async function (id) {
      try {
        let tremsArray = []
        const { data } = await http.get(`${constants.API_URL}/api/grade-module/parameter/${id}`)
        this.parameterName = data.gradeSubSkills[0].gradeParameters[0].name
        this.skill = data.name
        this.subSkill = data.gradeSubSkills[0].name
        // this.termId = data.gradeSubSkills[0].gradeParameters[0].gradePrameterTermMaps[0].academicTerms[0].name
        this.termValues = data.gradeSubSkills[0].gradeParameters[0].gradePrameterTermMaps
        this.termValues.forEach((obj) => {
          if (_.isArray(obj.academicTerms)) {
            obj.academicTerms.forEach((item) => {
              if (item.name) {
                tremsArray.push(item.name)
              }
            })
          }
        })
        if (tremsArray.length > 0) {
          this.termId = tremsArray.toString()
        }
        this.termID = data.gradeSubSkills[0].gradeParameters[0].id
        this.restoreModel = true
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    clearData () {
      this.parameterName = ''
      this.remark = ''
      this.desc = ''
      this.editMode = false
      this.termId = []
      this.position = null
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg

      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    deleteGradeParameter: async function (gradeSkillID) {
      let ref = this
      try {
        ref.isLoading = true
        await http.delete(`${constants.API_URL}/api/grade-module/${gradeSkillID}`)
        ref.isLoading = false
        await ref.getParameters()
        this.deleteModel = false
        return ref.$dialog.info({
          title: 'Success',
          text: 'Deactivated Grade Parameter Successfully'
        })
      } catch (e) {
        ref.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return ref.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    restoreGradeParameter: async function (gradeSkillID) {
      let ref = this
      try {
        ref.isLoading = true
        await http.put(`${constants.API_URL}/api/grade-module/restore/${gradeSkillID}`)
        ref.isLoading = false
        await ref.getParameters()
        this.restoreModel = false
        return ref.$dialog.info({
          title: 'Success',
          text: 'Grade Parameter restored successfully!'
        })
      } catch (e) {
        console.log(e)
        ref.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error in restoring User : ', errorMessage)
        return ref.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    }
  }
}
</script>
<style scoped>
.no-show {
  visibility: hidden;
}
</style>
